import React from 'react';
import html from 'remark-html';
import markdown from 'remark-parse';
import unified from 'unified';
import PropTypes from 'prop-types';

// Components
import Image from '../../Image/Image';
import Link from '../../Link/Link';
// Style
import './tag-list-item.scss';

const TagListItem = ({ url, fieldValue, image, excerpt }) => (
  <div className="tagListItem p-2 mb-3 m-1">
    <Link href={url || `/category/${fieldValue.toLowerCase()}/`}>
      {image ? (
        <Image img={image} alt={fieldValue} customClass="tag-img" height={225} />
      ) : (
        <Image
          img={`https://source.unsplash.com/featured/?${fieldValue}`}
          alt={fieldValue}
          height={225}
          customClass="tag-img"
        />
      )}
      <p className="tagListItem-text text-bold text-capitalize text-dark my-1">{fieldValue}</p>
      {excerpt ? (
        <div
          style={{ color: '#24273F' }}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: unified()
              .use(markdown)
              .use(html)
              .processSync(`${excerpt.slice(0, 110)}...`),
          }}
        />
      ) : null}
    </Link>
  </div>
);

TagListItem.defaultProps = {
  excerpt: '',
};

TagListItem.propTypes = {
  url: PropTypes.string.isRequired,
  fieldValue: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  excerpt: PropTypes.string,
};

export default TagListItem;
